import axios from 'axios';

import { BASE_FRONT_END_URL, BASE_URL, HTTP_STATUS } from '@/constants/constant';

import deploymentDetector from '@/services/deploymentDetector';

const headers = {
	'Content-Type': 'application/json',
	Accept: 'application/json'
};

export const routes = {
	userInfo: `${BASE_URL}/user/me`, // get
	myColleaguesSummary: `${BASE_URL}/user/my-colleagues/summary`,
	myColleaguesFilterOptions: `${BASE_URL}/user/my-colleagues/filter-options`,
	userStrengthInfo: `${BASE_URL}/user/tags/`, // get
	userUpdateTag: `${BASE_URL}/user/update-tags`,
	updateProfile: `${BASE_URL}/user/update-basic-info`, //post
	updateProPic: `${BASE_URL}/user/update-profile-picture`, //post
	updatePassword: `${BASE_URL}/user/change-password`, //post
	getCompanyList: `${BASE_URL}/company/search`, //post
	login: `${BASE_URL}/auth/login-admin`, // POST
	signup: `${BASE_URL}/auth/signup`, // POST
	totalLikedProduct: `${BASE_URL}/user/favourites/unseen-count`,
	forgetPassword: `${BASE_URL}/user/request-forgot-password`, // POST
	completeForgotPassword: `${BASE_URL}/user/complete-forgot-password`, // POST
	updateBusinessInfo: `${BASE_URL}/user/update-business-info`, // POST
	addProduct: `${BASE_URL}/product/add`, // POST
	getProductList: `${BASE_URL}/product/my-product`, // GET
	getProductDetails: `${BASE_URL}/product/`, // GET
	getProductType: `${BASE_URL}/product-type/all`, // GET
	getProductTypeWithGroup: `${BASE_URL}/product-type/all-with-group`, // GET
	getAccessoriesList: `${BASE_URL}/accessories/by-product-type/`, // GET
	getSizeTableData: `${BASE_URL}/sizes/get-size-table/`, // GET
	likeProduct: `${BASE_URL}/product/like`, //post
	likeProductWithRequestBody: `${BASE_URL}/product/like-with-request-body`, //post
	unlikeProduct: `${BASE_URL}/product/unlike/`, //post
	updateProductStatus: `${BASE_URL}/product/update-product-status/`, //post
	getProductRefferenceNumber: `${BASE_URL}/product/dropdown`,
	productSearchHistory: `${BASE_URL}/product/search-history`,

	getDashboardDesignList: `${BASE_URL}/dashboard/design-by-nitex`, // GET
	// getPickDesign: `${BASE_URL}/product/for-pick-design`, // GET
	getOrderList: `${BASE_URL}/order/my-order`, // GET
	getOrderDetails: `${BASE_URL}/order/`, // GET
	submitDraftedOrder: `${BASE_URL}/order/`, // POST
	getDealSplitCandidates: `${BASE_URL}/order/`, // POST, suffixed with `${orderId}/deal-split-candidates`
	deleteDraftedOrder: `${BASE_URL}/order/`, // DELETE, suffixed with `${orderId}/draft`
	getMarket: `${BASE_URL}/product-group/all`, // GET
	getProductGroup: `${BASE_URL}/product-group/all`, // GET
	getDesignDetails: `${BASE_URL}/product/style-info/`,
	getDocumentResponse: `${BASE_URL}/product/groupwise-doc/`,
	upDateDesign: `${BASE_URL}/product/style-info/`,
	unlikeAllProduct: `${BASE_URL}/product/unlike`, //post
	getPickAndChoosePrice: `${BASE_URL}/product/pick-and-choose-price`,
	productListFilterOptions: `${BASE_URL}/product/filter-options`,
	toggleBuyerVisibility: `${BASE_URL}/product/buyer-visibility`,

	getRfqList: `${BASE_URL}/rfq/my-rfq`,
	getRfqListV2: `${BASE_URL}/rfq/my-quotes`, // GET (new integration)
	updateRfqColorSize: `${BASE_URL}/rfq/color-wise-size/`,
	updateRfqColorWisePrice: `${BASE_URL}/rfq/color-size-wise-price/`,
	sendRfqOffer: `${BASE_URL}/rfq/price/`,
	getRfqDetails: `${BASE_URL}/rfq/`,
	updateRfqInfo: `${BASE_URL}/rfq/update-info`,
	duplicateRfq: `${BASE_URL}/rfq/duplicate/`,
	deleteRfq: `${BASE_URL}/rfq/delete`,
	deleteDuplicateRfq: `${BASE_URL}/rfq/duplicate`,

	rfqChangeApprovalRequests: `${BASE_URL}/rfq/change-approval-requests`,
	rfqChangeApprovalRequestsByOrder: `${BASE_URL}/rfq/change-approval-requests/order`,
	rfqChangeApprovalRequestCount: `${BASE_URL}/rfq/change-approval-requests/count`,
	approveRfqUpdateRequest: `${BASE_URL}/rfq/approve-rfq-update-request`,
	getRfqChangeLog: `${BASE_URL}/rfq/`, // GET, append `${rfqId}/change-log`

	getRfqNegotiationMessages: `${BASE_URL}/product/get-messages/`,
	sendRfqNegotiationMessage: `${BASE_URL}/rfq/send-message/`,
	getDeliverableMessages: `${BASE_URL}/deliverable/get-messages/`,
	sendDeliverableMessages: `${BASE_URL}/deliverable/send-message/`,
	getProjectProductDetails: `${BASE_URL}/order/product/`,
	addRfq: `${BASE_URL}/rfq/add`,
	addProject: `${BASE_URL}/order/add`,
	getMostTaggedTopics: `${BASE_URL}/order-timeline/most-tagged-topic/`,
	getUpcomingDeadlines: `${BASE_URL}/order/nearest-deliverable-list/`,
	getPostsForProject: `${BASE_URL}/order-timeline/order/`,
	getFeedbackForPost: `${BASE_URL}/order-timeline/comment-by-post/`,
	sendPost: `${BASE_URL}/order-timeline/new-post`,
	sendFeedback: `${BASE_URL}/order-timeline/new-comment`,
	updateDeliverables: `${BASE_URL}/deliverable/update-status-and-deadline/`,
	authGoogle: `${BASE_URL}/oauth2/authorize/google`,
	authLinkedin: `${BASE_URL}/oauth2/authorize/linkedin`,
	getProjectInvoice: `${BASE_URL}/invoice/order/`,
	payForInvoice: `${BASE_URL}/invoice/pay`,
	addInvoice: `${BASE_URL}/invoice/add`,
	editInvoice: `${BASE_URL}/invoice/edit/`,
	invoiceAction: `${BASE_URL}/invoice/`,
	approveInvoiceSlip: `${BASE_URL}/payment/approve`,
	rejectInvoiceSlip: `${BASE_URL}/payment/reject/`,
	invoicePayment: `${BASE_URL}/invoice/update-receive-amount/`,
	changeInvoiceStatus: `${BASE_URL}/invoice/change-status-to-paid/`,
	getAllUnseenNotificationCount: `${BASE_URL}/notification/unseen-count/all`,
	getNotifications: `${BASE_URL}/notification/all`,
	markNotificationRead: `${BASE_URL}/notification/mark-seen`,
	markNotificationUnread: `${BASE_URL}/notification/mark-unseen`,
	markAllNotificationUnreadByCategory: `${BASE_URL}/notification/mark-all-seen-by-category`,
	markNotificationImportant: `${BASE_URL}/notification/mark-important`,
	markNotificationUnImportant: `${BASE_URL}/notification/mark-unimportant`,
	deleteInvoice: `${BASE_URL}/invoice/`,

	getColleagues: `${BASE_URL}/user/my-colleagues`,
	getAdmins: `${BASE_URL}/user/all-admin`,
	addAdmin: `${BASE_URL}/user/create-admin`,
	editAdmin: `${BASE_URL}/user/admin/`,
	getAdminDetails: `${BASE_URL}/user/admin/`,
	deleteAdmin: `${BASE_URL}/user/delete-admin/`,
	changeAdminStatus: `${BASE_URL}/user/admin/change-status`,
	getClients: `${BASE_URL}/user/all-client`,
	addClient: `${BASE_URL}/user/create-client`,
	editClient: `${BASE_URL}/user/client/`,
	changeUserPassword: `${BASE_URL}/user/reset-password/`,
	getClientDetails: `${BASE_URL}/user/client/`,
	deleteClient: `${BASE_URL}/user/delete-client/`,
	changeClientStatus: `${BASE_URL}/user/admin/change-status`, //same as admin changing status
	getManageProducts: `${BASE_URL}/product/search`,
	deleteProduct: `${BASE_URL}/product/`,
	EditProduct: `${BASE_URL}/product/edit/`,
	getRoles: `${BASE_URL}/user/all-roles`,
	getRolesV2: `${BASE_URL}/user-level/all`,
	getUserTypes: `${BASE_URL}/user/all-user-types`,
	getUserTypesWithBuyer: `${BASE_URL}/user/all-user-types-with-buyer`,
	getStatus: `${BASE_URL}/user/all-status`,
	getManagers: `${BASE_URL}/user/all-manager`,
	getExecutives: `${BASE_URL}/user/all-executive`,

	manageProjectList: `${BASE_URL}/order/manage-order`,
	deleteProject: `${BASE_URL}/order/delete/`,
	getProjectBasicInfo: `${BASE_URL}/order/get-basic-info/`,
	updateProjectBasicInfo: `${BASE_URL}/order/update-basic-info/`,
	getProjectProducts: `${BASE_URL}/order/get-product-list/`,
	deleteProjectProducts: `${BASE_URL}/order/remove-products/`,
	getProjectMembers: `${BASE_URL}/order/get-member-list/`,
	getProjectMemberList: `${BASE_URL}/order/get-team-response/`,
	getProjectUserSuggestions: `${BASE_URL}/user/find-list-by-email-and-user-type`,
	updateProjectMember: `${BASE_URL}/order/update-member-list/`,
	updateProductPrice: `${BASE_URL}/rfq/update-product-price/`,
	updateRfq: `${BASE_URL}/rfq/assign-executive/`,
	setSettingsData: `${BASE_URL}/personal-setting/set`,
	// getProductDetails: `${BASE_URL}/user/admin/change-status`,

	allInvoiceList: `${BASE_URL}/invoice/all`,
	getOrderItems: `${BASE_URL}/order/item-wise-price/`,
	getSettingsDataByUser: `${BASE_URL}/personal-setting/get/user/`,
	getSettingsData: `${BASE_URL}/personal-setting/get/`,

	getCollectionList: `${BASE_URL}/collection/search`,
	getUserType: `${BASE_URL}/user/all-user-types`,
	addCollection: `${BASE_URL}/collection/add`,
	updateCollection: `${BASE_URL}/collection/update`,
	deleteCollection: `${BASE_URL}/collection/delete`,

	// collection api
	addProductToCollection: `${BASE_URL}/collection/product/add`,
	getUserCollectionList: `${BASE_URL}/collection/search/user/`,
	getCollectionDetails: `${BASE_URL}/collection/`,
	getCollectionProducts: `${BASE_URL}/collection/products/`,
	getUsersByTypes: `${BASE_URL}/user/by-user-types`,
	shareCollection: `${BASE_URL}/collection/share`,
	getUserSuggestions: `${BASE_URL}/user/find-list-by-email-and-user-type`,
	getAllPublicCollection: `${BASE_URL}/collection/all-public`,
	getCollectionSuggestions: `${BASE_URL}/collection/suggestion/for-add`,
	removeMemberFromCollection: `${BASE_URL}/collection/remove-member`,
	getAllBrands: `${BASE_URL}/collection/brand/all`,
	removeProductFromCollection: `${BASE_URL}/collection/product/remove`,
	moveToCollection: `${BASE_URL}/collection/product/move-to-another`,
	collectionAction: `${BASE_URL}/collection/`,
	savePresentationSequence: `${BASE_URL}/presentation/sequence`,
	placeOrderFromCosting: `${BASE_URL}/collection/place-order`,
	createOption: `${BASE_URL}/collection/product/`,
	pinCollection: `${BASE_URL}/collection/`,
	collectionFilterOptions: `${BASE_URL}/collection/filter-options`,

	getSettings: `${BASE_URL}/setting/get/`,
	setSettings: `${BASE_URL}/setting/set`,
	uploadDocument: `${BASE_URL}/doc/add`,
	doExists: `${BASE_URL}/doc/do-exist`,
	uploadDocumentInProduct: `${BASE_URL}/product/doc/add/`,
	shareDesign: `${BASE_URL}/product/share-design`,
	designLooks: `${BASE_URL}/enum/list/info.nitex.app.product.DesignLook`,
	getShareDesignDetails: `${BASE_URL}/product/share-design/`,
	updateDesignDetails: `${BASE_URL}/product/share-design/`,
	updateSizeTable: `${BASE_URL}/product/size/`,
	updateAdvancedSettings: `${BASE_URL}/product/administrative-info/`,
	getDesignImages: `${BASE_URL}/product/doc/`,
	getDesignCategories: `${BASE_URL}/category/all`,
	getDesignSubCategories: `${BASE_URL}/category/subcategory/all`,
	addNewProduct: `${BASE_URL}/product/add`,
	addDesigns: `${BASE_URL}/product/add-inspiration`,
	uploadSingleStyle: `${BASE_URL}/product/add-inspiration-single-style`,
	addFromInspiration: `${BASE_URL}/product/add-from-inspiration`,
	publishDesign: `${BASE_URL}/product/`,
	unPublishDesign: `${BASE_URL}/product/`,
	getDesignFilterCategory: `${BASE_URL}/product/filter-category`,
	getColorsOfProduct: `${BASE_URL}/product/`,
	getCategoryWiseSubCategoryCount: `${BASE_URL}/category/subcategory-count`,
	categoryAction: `${BASE_URL}/category/`,

	addRole: `${BASE_URL}/user-level/add`,
	role: `${BASE_URL}/user-level/`,
	getRolesList: `${BASE_URL}/user-level/all`,
	getRoleWithDepartment: `${BASE_URL}/user-level/all-with-department`,
	getGroupedRoleList: `${BASE_URL}/user-level/all-roles-grouped`,
	getRolesPermissionList: `${BASE_URL}/user-level/get-role-list-by-user-level/`,
	getMenusOrder: `${BASE_URL}/user-level/menus-in-order`,
	getAllMenus: `${BASE_URL}/role/all-menus`,

	getAllTeams: `${BASE_URL}/team/all`,
	addTeam: `${BASE_URL}/team/add`,
	teamOperation: `${BASE_URL}/team/`,

	getSimilarDesign: `${BASE_URL}/product/similar/`,

	getBrandSuggestions: `${BASE_URL}/brand/prefix/`,
	getProductsForRfq: `${BASE_URL}/product/for-rfq`,
	searchProduct: `${BASE_URL}/product/search`,

	addForCosting: `${BASE_URL}/costing/add`,
	addForCostingBulk: `${BASE_URL}/costing/add/bulk`,
	getCollectionCostingList: `${BASE_URL}/costing/collection/`,
	costing: `${BASE_URL}/costing/`,
	getFolderDetailsFilterFields: `${BASE_URL}/product/favourite/filter-options`,
	getCollectionDetailsFilterFields: `${BASE_URL}/collection/filter-options`,

	//order apis
	order: `${BASE_URL}/order/place-order`,
	orderFromCosting: `${BASE_URL}/costing/place-order`,
	updateOrderAddress: `${BASE_URL}/order/update-address`,
	removeOrderItem: `${BASE_URL}/order/place-order/remove-item`,
	cancelOrder: `${BASE_URL}/order/cancel-order/`,
	getOrderMaterials: `${BASE_URL}/order/materials/`,
	addOrderMaterial: `${BASE_URL}/order/add-materials/`,
	updateOrderMaterial: `${BASE_URL}/order/materials/`,
	removeOrderMaterial: `${BASE_URL}/order/materials/`,
	getInitialOrderPlan: `${BASE_URL}/order/get-tna-template`,
	addStyleToOrder: `${BASE_URL}/order/`,
	downloadTnaExcelFile: `${BASE_URL}/tna-planning/excel/download/order/`,
	uploadTnaExcelFile: `${BASE_URL}/tna-planning/excel/upload/order/`,

	/**  TNA APIs URL  */
	getInitialAllOrder: `${BASE_URL}/order/get-product-list`,
	tnaPlanningOrder: `${BASE_URL}/tna-planning/order`,
	getTnaTemplateDay: `${BASE_URL}/tna-planning/templates/all`,
	searchDuplicablePlans: `${BASE_URL}/tna-planning/plans/search`,
	getRunningAllOrder: `${BASE_URL}/order`,
	getRunningTnaStyleDetails: `${BASE_URL}/step/order-details/order`,
	submitTna: `${BASE_URL}/tna-planning/order`,
	submitRunningTna: `${BASE_URL}/order`,
	stepUrl: `${BASE_URL}/step`,
	subTaskAction: `${BASE_URL}/step/sub-task/`,
	startOrder: `${BASE_URL}/order`,
	/**  TNA APIs URL  */
	/* Conversation websocket */
	webSocketUrl: `${BASE_URL}/ws`,
	getQouteRequestConversation: `${BASE_URL}/conversation/quote-request`,
	getCollectionConversation: `${BASE_URL}/conversation/collection`,
	getPhotographyConversation: `${BASE_URL}/conversation/photography`,
	getConversationTopic: `${BASE_URL}/conversation/topics`,
	addPostOnSample: `${BASE_URL}/sample-development-comment/new-post`,
	addReplyOnSample: `${BASE_URL}/sample-development-comment/new-comment`,
	getPostBySampleID: `${BASE_URL}/sample-development-comment`,
	addNewConversationPost: `${BASE_URL}/conversation/new-post`,
	addNewConversationComment: `${BASE_URL}/conversation/new-comment`,
	/* Conversation websocket */

	createTna: `${BASE_URL}/order/create-tna`,
	// getStepResponseForOrderDetails: `${BASE_URL}/order/step-response-for-order-details`,
	addMemberToOrder: `${BASE_URL}/order/assign-member/`,
	removeMemberFromOrder: `${BASE_URL}/order/remove-members/`,
	addProjectManagerToOrder: `${BASE_URL}/order/assign-project-manager/`,
	addAccountManagerToOrder: `${BASE_URL}/order/assign-account-manager/`,
	getOrderQuotes: `${BASE_URL}/order/quotes/`,
	getTnaStatus: `${BASE_URL}/order/is-plan-created/`,
	createOrder: `${BASE_URL}/rfq/product-default-quotes`,
	placeOrder: `${BASE_URL}/order/place-order-with-products`,
	getStatusCount: `${BASE_URL}/order/status-wise-count`,
	getOrderPlacementStatus: `${BASE_URL}/workflow/order-placement/status/`,
	addPoToOrder: `${BASE_URL}/order/add-po-doc/`,
	tagSupplier: `${BASE_URL}/order/tag-supplier/`,
	syncData: `${BASE_URL}/order/`,

	// tna
	downloadTna: `${BASE_URL}/step/download-tna/`,

	getPaymentSession: `${BASE_URL}/invoice/pay-via-gateway`,
	//updatePaymentStatus: `${BASE_URL}/payment/confirm`,
	getUnseenNotificationCount: `${BASE_URL}/notification/unseen-count`,

	getAllDeliverables: `${BASE_URL}/deliverable/all`,
	getProductDeliverables: `${BASE_URL}/deliverable/all-deliverable-by-product/`,
	assignDeliverablesToProduct: `${BASE_URL}/deliverable/assign-deliverable-to-product/`,

	myTaskCount: `${BASE_URL}/step/tasks/my-tasks-count`,
	getMyTasks: `${BASE_URL}/step/tasks/my-tasks`,
	task: `${BASE_URL}/step/`,
	addDeleteMemberToTask: `${BASE_URL}/step/add-delete-member`,
	orderTimelineAction: `${BASE_URL}/order-timeline/`,
	commentOnTask: `${BASE_URL}/order-timeline/new-comment`,
	postOnTask: `${BASE_URL}/order-timeline/new-post`,
	approveTask: `${BASE_URL}/step/approve/`,
	reviseTask: `${BASE_URL}/step/revise/`,
	addNewTask: `${BASE_URL}/step/add`,

	// stage api
	updateStage: `${BASE_URL}/stage/`,
	completeStage: `${BASE_URL}/stage/complete/`,

	// brands api
	getBrandList: `${BASE_URL}/brand/allWithLogo`,
	getBrandBasicList: `${BASE_URL}/brand/all`,
	getBrandInfo: `${BASE_URL}/brand/details/`,
	updateBrandInfo: `${BASE_URL}/brand/update`,
	addBrandInfo: `${BASE_URL}/brand/add`,
	getBrandLocations: `${BASE_URL}/brand/locations/`,
	addBrandLocation: `${BASE_URL}/brand/add-location/`,
	makeLocationDefault: `${BASE_URL}/brand/locations/make-default/`,
	getTeamBrands: `${BASE_URL}/team/brand/`,
	getBrandWithSubBrand: `${BASE_URL}/brand/`,
	getTeamBrandList: `${BASE_URL}/team/brand`,

	// dashboard api
	getBusinessOverView: `${BASE_URL}/dashboard/business-overview`,
	getBrandPerformance: `${BASE_URL}/dashboard/brand-performance`,
	getTeamPerformance: `${BASE_URL}/dashboard/team-performance`,
	getFilterByStatus: `${BASE_URL}/order/all/filterByStatus`,
	getBrandStatus: `${BASE_URL}/brand/all/all-page`,
	getOrderPerfomance: `${BASE_URL}/dashboard/order-performance`,
	getOverdueTasks: `${BASE_URL}/dashboard/overdue-tasks`,
	getAllTasks: `${BASE_URL}/step/tasks/all-tasks`,
	allTaskFilterOptions: `${BASE_URL}/dashboard/all-tasks-filter-options`,

	// extract po api
	uploadBoohooDocument: `${BASE_URL}/order/extract-boohoo-po`,

	// download ppt
	downloadPpt: `${BASE_URL}/presentation/download`,

	// season api
	getAllSeasons: `${BASE_URL}/material/season/all`,

	// fabric api
	getFabricCategory: `${BASE_URL}/material/fabric/construction-groups`,
	getFabricTypes: `${BASE_URL}/material/fabric-type/all`,
	getFabricSubCategory: `${BASE_URL}/material/fabric/constructions`,
	addFabricSubCategory: `${BASE_URL}/material/fabric/construction`,
	editFabricSubCategory: `${BASE_URL}/material/fabric/construction/`,
	getCompositionNameList: `${BASE_URL}/material/fabric/composition-name-list`,
	getAllFabrics: `${BASE_URL}/material/fabric-library/all`,
	setParseInputName: `${BASE_URL}/material/fabric/parse-inputted-name`,
	getCompositionParts: `${BASE_URL}/material/fabric/composition-parts`,
	getCompositionDetails: `${BASE_URL}/material/fabric/composition-details`,
	getBulkUploadMaterialDoc: `${BASE_URL}/material/bulk-upload-material-doc`,
	getUploadMaterialDoc: `${BASE_URL}/material/upload-material-doc`,
	addFabricWithSupplier: `${BASE_URL}/material/fabric/fabric-with-supplier/add`,
	duplicateFabricWithSupplier: `${BASE_URL}/material/fabric/fabric-with-supplier/duplicate`,
	updateFabricWithSupplierDetails: `${BASE_URL}/material/fabric/fabric-with-supplier/update/`,
	materialStockQuantityInfo: `${BASE_URL}/material/stock-quantity-info`,
	getAllFabricPatterns: `${BASE_URL}/material/fabric-patterns`,
	restrictBooking: `${BASE_URL}/material/inventory/received-log`,
	getReservationPeriods: `${BASE_URL}/material/inventory/reservation-periods`,
	serchFabricByDescription: `${BASE_URL}/material/semantic-search/fabric`,
	getCompositionsList: `${BASE_URL}/material/fabric/compositions`,

	//color api
	getAllColors: `${BASE_URL}/color/pantone/search`,
	getAllColorGroup: `${BASE_URL}/color/group/all`,
	addColor: `${BASE_URL}/color/pantone/add`,
	addPantoneColorToProduct: `${BASE_URL}/color/add-pantone-color-to-product/`,
	addColorToDesign: `${BASE_URL}/color/add/`,
	removeColor: `${BASE_URL}/color/remove/`,

	// material api
	getProductMaterials: `${BASE_URL}/product/material/`,
	addMaterialToProduct: `${BASE_URL}/product/material/add/`,
	addMaterialWithBookedToProduct: `${BASE_URL}/product/material/add-with-booked/`,
	materialBookedToProduct: `${BASE_URL}/product/material/booked/`,
	replaceMaterialFromProduct: `${BASE_URL}/product/material/replace/`,
	removeMaterialFromProduct: `${BASE_URL}/product/material/remove/`,
	removeMaterialFromProductList: `${BASE_URL}/product/material/removeById/`,
	getProductMaterialHistory: `${BASE_URL}/product/`,

	updateProductMaterial: `${BASE_URL}/product/update/`,
	getSuppliersMaterials: `${BASE_URL}/material/all`,
	getAllMaterialsBrief: `${BASE_URL}/material/all/material-brief`,
	getAllComposition: `${BASE_URL}/material/composition/all`,
	getAllMaterials: `${BASE_URL}/material/library/all`,
	addPairMaterial: `${BASE_URL}/material/`,
	deletePairMaterial: `${BASE_URL}/material/`,
	getPairMaterials: `${BASE_URL}/material/pair-material`,
	getPairMaterialsForProduct: `${BASE_URL}/material/product/pair-material`,
	hideMaterialColor: `${BASE_URL}/material/`,

	getFabricWithSupplierDetails: `${BASE_URL}/material/fabric/fabric-with-supplier/`,
	addFabric: `${BASE_URL}/material/fabric/add`,
	fabricDetails: `${BASE_URL}/material/fabric/`,
	updateFabricDetails: `${BASE_URL}/material/fabric/update/`,

	getAllTrims: `${BASE_URL}/material/trims/trims-category/all`,
	getTrimsType: `${BASE_URL}/material/trims/trims-type/all`,
	addTrimsWithSupplier: `${BASE_URL}/material/trims/trims-with-supplier/add`,
	duplicateTrimsWithSupplier: `${BASE_URL}/material/trims/trims-with-supplier/duplicate`,
	updateTrimsWithSupplier: `${BASE_URL}/material/trims/trims-with-supplier/update`,
	trimsSubCategories: `${BASE_URL}/material/trims/sub-categories`,
	trimsAllMaterialNumber: `${BASE_URL}/material/trims/material-number/all/`,
	trimsDetails: `${BASE_URL}/material/trims/`,
	updateTrims: `${BASE_URL}/material/trims/update/`,
	getTrimsSubType: `${BASE_URL}/material/trims/sub-category`,

	addBrandingWithSupplier: `${BASE_URL}/material/branding/branding-with-supplier/add`,
	duplicateBrandingWithSupplier: `${BASE_URL}/material/branding/branding-with-supplier/duplicate`,
	updateBrandingWithSupplier: `${BASE_URL}/material/branding/branding-with-supplier/update`,
	addNewBranding: `${BASE_URL}/material/branding/add`,
	brandingDetails: `${BASE_URL}/material/branding/`,
	updateBranding: `${BASE_URL}/material/branding/update/`,
	getLabelPackSubTypes: `${BASE_URL}/material/branding/sub-category`,
	getBrandingCategories: `${BASE_URL}/material/branding/branding-category/all`,
	getBrandingTypes: `${BASE_URL}/material/branding/branding-type/all`,
	brandingSubCategories: `${BASE_URL}/material/branding/sub-categories`,
	brandingAllMaterialNumber: `${BASE_URL}/material/branding/material-number/all/`,

	getEmbellishmentSubCategory: `${BASE_URL}/material/embellishment/sub-category`,

	materialAction: `${BASE_URL}/material/`,
	applicationGarmentsType: `${BASE_URL}/material/app-garments-types`,
	inventoryIssueLogStatusUpdated: `${BASE_URL}/material/inventory/issue-log-status/update/`,
	inventoryReceivedLogStatusUpdated: `${BASE_URL}/material/inventory/received-log-status/update/`,

	getPinnedMaterial: `${BASE_URL}/collection/pinned-materials`,
	materialPin: `${BASE_URL}/collection/product/`,
	updateMaterialRoadmap: `${BASE_URL}/supplier/material-roadmap/update`,
	fabricFilterOptions: `${BASE_URL}/material/fabric/filter-options`,
	markAsLowQty: `${BASE_URL}/material/mark-as-low-qunatity`,
	undoInventoryWastage: `${BASE_URL}/material/inventory/wastage/`,
	trimsListFilterOptions: `${BASE_URL}/material/trims/filter-options`,
	accessoriesListFilterOptions: `${BASE_URL}/material/branding/filter-options`,
	addAdditionalFabric: `${BASE_URL}/product/material/reissue`,

	// measurment api
	getPomAndSize: `${BASE_URL}/product-measurement/pom-and-size/all`,
	addSizeToProduct: `${BASE_URL}/product-measurement/add-size`,
	removeSizeFromProduct: `${BASE_URL}/product-measurement/remove-size`,
	getProductMeasurement: `${BASE_URL}/product-measurement/`,
	addPomToProduct: `${BASE_URL}/product-measurement/add-point-of-measurement`,
	removePomFromProduct: `${BASE_URL}/product-measurement/remove-point-of-measurement`,
	updateCellValue: `${BASE_URL}/product-measurement/update-cell-value`,
	addGrading: `${BASE_URL}/product-measurement/add-grading`,
	addNewPom: `${BASE_URL}/product-measurement/point-of-measurement/add`,
	saveAsTemplate: `${BASE_URL}/product-measurement/save-as-template`,
	getAllTemplate: `${BASE_URL}/product-measurement/template/all`,
	loadFromTemplate: `${BASE_URL}/product-measurement/load-from-template`,
	defaultSizeCategory: `${BASE_URL}/product-measurement/size/default-category`,
	addSizeCategory: `${BASE_URL}/product-measurement/size/category`,
	editSizeCategory: `${BASE_URL}/product-measurement/size/category/`,
	getSizeCategory: `${BASE_URL}/product-measurement/size/category/`,
	allSizeCategory: `${BASE_URL}/product-measurement/size/categories/all`,
	getAvailableSizeForProduct: `${BASE_URL}/product-measurement/size/available-to-add/`,
	getSizeList: `${BASE_URL}/product-measurement/sizes/all`,
	updateProductMeasurement: `${BASE_URL}/product-measurement/product/`,
	updateProductMeasurementBlock: `${BASE_URL}/product-measurement/update-block-info/`,
	updateProductEmbellishment: `${BASE_URL}/product/update-embellishment`,
	measuremrntPdfDownload: `${BASE_URL}/product/download-measurement-chart/`,
	pomVisual: `${BASE_URL}/library-pom/visual/`,
	pomSerialList: `${BASE_URL}/library-pom/serial/all`,
	pomAction: `${BASE_URL}/library-pom/`,
	getAllPomList: `${BASE_URL}/library-pom/all`,
	getPomListPageFilter: `${BASE_URL}/library-pom/filter/options`,
	getMeasurementTemplateResponse: `${BASE_URL}/library-pom/measurement-template/subcategory/`,
	blockSuggestionFilterOptions: `${BASE_URL}/product/blocks/filter-options`,
	loadPomTemplate: `${BASE_URL}/product-measurement/load-pom-template`,
	getAllPomResponse: `${BASE_URL}/library-pom/pom-response/all`,

	// group document api
	addNewGroupDocument: `${BASE_URL}/product/document-group/add`,
	updateGroupDocument: `${BASE_URL}/doc/group/`,
	addNoteToDocument: `${BASE_URL}/product/document-group/add-note`,

	// initial costing
	getCosting: `${BASE_URL}/initial-costing/product/`,
	addCosting: `${BASE_URL}/initial-costing/add`,
	getCostingSheet: `${BASE_URL}/costing-sheet/collection/`,
	quantityWiseCosting: `${BASE_URL}/quantity-wise-cost/add`,
	getQuantityWiseCosting: `${BASE_URL}/quantity-wise-cost/product/`,
	quantityWiseCostingAction: `${BASE_URL}/quantity-wise-cost/`,
	addQuantityToCostingSheet: `${BASE_URL}/costing-sheet/add-quantity/`,
	costingSheetUpdatePrice: `${BASE_URL}/costing-sheet/update-price`,
	getInitialCostingList: `${BASE_URL}/initial-costing/request-to-me`,
	getProductStepList: `${BASE_URL}/workflow/upload-product/status/`,
	inititalCostingStepperStatus: `${BASE_URL}/workflow/initial-costing/status/`,
	requestForCosting: `${BASE_URL}/initial-costing/request`,
	downloadCostingSheet: `${BASE_URL}/costing-sheet/download/`,
	// getMyQuotesProduct: `${BASE_URL}/costing-sheet/product-default-quotes`,
	placeOrderFromCollection: `${BASE_URL}/costing-sheet/place-order`,
	costingSheetUpdate: `${BASE_URL}/costing-sheet/update/`,
	addFabricToCostingSheet: `${BASE_URL}/costing-sheet/add-fabric/`,
	approveOffer: `${BASE_URL}/costing-sheet/approve-offer/`,
	recosting: `${BASE_URL}/costing-sheet/request-for-recosting/`,
	getRequestedBy: `${BASE_URL}/initial-costing/recosting/distinct-requested-by`,
	getDistinctCollection: `${BASE_URL}/initial-costing/recosting/distinct-collection`,
	getRecostingRequest: `${BASE_URL}/initial-costing/recosting/my-request`,
	updateBasePriceByCostingManager: `${BASE_URL}/costing-sheet/update-base-price-by-costing-manager`,
	addBulkInitialCosting: `${BASE_URL}/initial-costing/bulk-request`,
	fetchInitialCostingListPageFilter: `${BASE_URL}/initial-costing/request/filter-options`,
	fetchInitialCostingDesignsFilterOptions: `${BASE_URL}/initial-costing/filter-options`,
	fetchInitialCostingDesignsList: `${BASE_URL}/initial-costing/designs`,

	// supplier api
	getAllSupliers: `${BASE_URL}/supplier/type/all`,
	getAllCountry: `${BASE_URL}/supplier/country/all`,
	getSupplierCityByCountry: `${BASE_URL}/supplier/city/filter-by-country/`,
	getSuplierCategory: `${BASE_URL}/supplier/category/filter-by-type`,
	addSuplier: `${BASE_URL}/supplier/add`,
	getSuppliersDetails: `${BASE_URL}/supplier/location-contact-info/`,
	getSuppliersPhotoGallarey: `${BASE_URL}/supplier/photo-documents/`,
	getSuppliersCertificates: `${BASE_URL}/supplier/certificates/`,
	getSuppliersReviewSummaries: `${BASE_URL}/supplier/review-summary/`,
	getSuppliersReviews: `${BASE_URL}/supplier/reviews/`,
	updateSupplierInfo: `${BASE_URL}/supplier/update-factory-info/`,
	updateContactPerson: `${BASE_URL}/supplier/contact-person/`,
	addContactPerson: `${BASE_URL}/supplier/contact-person/add/`,
	removeContactPerson: `${BASE_URL}/supplier/contact-person/`,
	updateLocation: `${BASE_URL}/supplier/location/`,
	updateCertificate: `${BASE_URL}/supplier/certificate/`,
	updatePhotoDocument: `${BASE_URL}/supplier/photo-document/update/`,
	addPhotoDocument: `${BASE_URL}/supplier/photo-documents/add/`,
	removePhotoDocument: `${BASE_URL}/supplier/photo-document/delete/`,
	updateReview: `${BASE_URL}/supplier/review/`,
	addReview: `${BASE_URL}/supplier/reviews/add/`,
	addCertificate: `${BASE_URL}/supplier/certificate/add/`,
	removeCertificate: `${BASE_URL}/supplier/certificate/`,
	addSupplierMaterialtag: `${BASE_URL}/supplier/material/tag`,
	addSupplierCopyMaterialTag: `${BASE_URL}/supplier/copy-material/tag`,
	deleteSupplierCopyMaterialTag: `${BASE_URL}/supplier/copy-material/delete/`,
	getSuppliersMaterialList: `${BASE_URL}/supplier/materials/`,
	updateTaggedMaterial: `${BASE_URL}/supplier/material/update`,
	deleteTaggedMaterial: `${BASE_URL}/supplier/material/delete`,
	getSupplier: `${BASE_URL}/supplier/search`,
	updateMaterialtag: `${BASE_URL}/supplier/material/update`,
	getSuppliersList: `${BASE_URL}/supplier/all`,
	deleteSupplier: `${BASE_URL}/supplier/`,
	deleteSupplierReview: `${BASE_URL}/supplier/review/`,
	getOrderSuppliers: `${BASE_URL}/supplier/order/`,
	supplierAddEvent: `${BASE_URL}/mixpanel/event/add/supplier_add_new`,
	supplierAddFromListEvent: `${BASE_URL}/mixpanel/event/add/supplier_add_list`,
	selectedSupplierFromMaterialEvent: `${BASE_URL}/mixpanel/event/add/supplier_select_product_on_select`,
	addNewMaterialFromSupplierListEvent: `${BASE_URL}/mixpanel/event/add/supplier_select_product_new_product`,
	addNewMaterialEvent: `${BASE_URL}/mixpanel/event/add/product_add_new_from_product_list`,
	updateMaterialEvent: `${BASE_URL}/mixpanel/event/add/product_edit_from_product_view`,
	getAllSuplierQuotes: `${BASE_URL}/supplier-quote/`,
	updateQuotes: `${BASE_URL}/supplier-quote/update-quote`,
	updateEtd: `${BASE_URL}/supplier-quote/update-delivery-date`,
	tagQuoteSupplier: `${BASE_URL}/supplier-quote/tag-supplier/`,
	unTagQuoteSupplier: `${BASE_URL}/supplier-quote/untag-supplier`,
	splitStyleFromSupplier: `${BASE_URL}/supplier-quote/split-style`,
	sendFactoryPriceApproval: `${BASE_URL}/supplier-quote/send-factory-price-approval`,
	getSupplierBankDetailsList: `${BASE_URL}/supplier/bank-details/`,
	addSupplierBankDetails: `${BASE_URL}/supplier/add-bank-details/`,
	makeDefaultBankDetails: `${BASE_URL}/supplier/bank-details/make-default/`,
	supplierAction: `${BASE_URL}/supplier/`,
	supplierDependentFilterList: `${BASE_URL}/supplier/filter/all`,
	productSampleInventory: `${BASE_URL}/product-sample-inventory`,
	getProductSampleLocations: `${BASE_URL}/product-sample-inventory/location/`,
	addNewSampleInventory: `${BASE_URL}/product-sample-inventory/add`,
	locationsTag: `${BASE_URL}/tags/all`,
	updateCountryLocation: `${BASE_URL}/product-sample-inventory/update-location`,
	downloadSKUReport: `${BASE_URL}/product-sample-inventory/sku-qr/download`,

	// materials api
	getGarmentsDetails: `${BASE_URL}/material/garments/`,
	getFabricDetails: `${BASE_URL}/material/fabric/`,
	getEmbellishmentDetails: `${BASE_URL}/material/embellishment/`,
	getTrimsDetails: `${BASE_URL}/material/trims/`,
	getWashingDetails: `${BASE_URL}/material/washing/`,
	getBrandingDetails: `${BASE_URL}/material/branding/`,
	getMaterialSuppliers: `${BASE_URL}/material/suppliers/`,
	addNewGarments: `${BASE_URL}/material/garments/add`,
	updateGarments: `${BASE_URL}/material/garments/update/`,
	addNewEmbellishment: `${BASE_URL}/material/embellishment/add`,
	updateEmbellishment: `${BASE_URL}/material/embellishment/update/`,
	addNewWashing: `${BASE_URL}/material/washing/add`,
	updateWashing: `${BASE_URL}/material/washing/update/`,
	racLocationSearch: `${BASE_URL}/material/inventory/rac-location/search`,
	addUpdatedInventory: `${BASE_URL}/material/inventory/add-updated/`,
	getAllReceiveAndIssue: `${BASE_URL}/material/inventory/receive-issue/all/`,
	getMaterialRequestCodes: `${BASE_URL}/material/request-materials/request-codes`,
	searchMaterialReferenceNumber: `${BASE_URL}/material/ref-number/all`,
	updatedMaterialByMaterialIdAndIsExpired: `${BASE_URL}/material/expired/`,
	fetchSimilarMaterialApi: `${BASE_URL}/material/similar`,
	fetchFiberFabricList: `${BASE_URL}/material/fabric/fiber-list`,
	fetchAccessoriesList: `${BASE_URL}/material/branding/category/all`,
	fetchTrimsList: `${BASE_URL}/material/trims/category/all`,

	// tags api
	getAllTags: `${BASE_URL}/tags/all`,

	// download techpack
	downloadTechPack: `${BASE_URL}/product/download-techpack/`,
	downloadPublicTechPack: `${BASE_URL}/product/public-download-techpack/`,
	getTechPackPages: `${BASE_URL}/product/get-techpack-pages/`,
	getPublicTechPackPages: `${BASE_URL}/product/get-public-techpack-pages/`,

	getBrandWithCollections: `${BASE_URL}/collection/brand-wise-info`,
	getBrandCollections: `${BASE_URL}/collection/brand-wise/all`,
	getEnums: `${BASE_URL}/enum/list/`,
	getMyCollections: `${BASE_URL}/collection/my`,
	getCollectionOwners: `${BASE_URL}/collection/owner/all`,

	//workFlow add member
	addWorkflowMember: `${BASE_URL}/workflow/add-member`,
	removeWorkflowMember: `${BASE_URL}/workflow/remove-member`,

	// pi api
	getBrandLocaionList: `${BASE_URL}/brand/locations/`,
	updateBillingShippingAddress: `${BASE_URL}/invoice/billing-shipping-address/`,
	getBeneficiaryList: `${BASE_URL}/invoice/beneficiary/all`,
	getNitexBankDetails: `${BASE_URL}/invoice/nitex-bank-details/all`,
	updateBeneficiaryList: `${BASE_URL}/invoice/beneficiary/`,
	updateNitexBankDetails: `${BASE_URL}/invoice/nitex-bank-details/`,
	addItemToInvoice: `${BASE_URL}/invoice/add-item/`,
	updateItemToInvoice: `${BASE_URL}/invoice/update-item/`,
	deleteItemToInvoice: `${BASE_URL}/invoice/delete-item/`,
	downloadInvoice: `${BASE_URL}/invoice/download/`,
	approveInvoice: `${BASE_URL}/invoice/approve/`,
	requestInvoice: `${BASE_URL}/payment-document/order/`,

	// sales contract
	salesContractAction: `${BASE_URL}/sales-contract/`,
	getAllSupplierList: `${BASE_URL}/sales-contract/all/`,
	getSalesContractDetails: `${BASE_URL}/sales-contract/`,
	updateBeneficiaryDetails: `${BASE_URL}/sales-contract/update-beneficiary-details/`,
	updateBeneficiaryBankDetails: `${BASE_URL}/sales-contract/update-beneficiary-bank-details/`,
	updateBillingAddress: `${BASE_URL}/sales-contract/update-billing-address/`,
	updateBuyerBankDetails: `${BASE_URL}/sales-contract/update-buyer-bank-details/`,
	updateBillingConsignee: `${BASE_URL}/sales-contract/update-consignee/`,
	addNewOrderSummary: `${BASE_URL}/sales-contract/item/add/`,
	updateOrderSummary: `${BASE_URL}/sales-contract/update-item/`,
	deleteOrderSummary: `${BASE_URL}/sales-contract/delete-item/`,
	updateSalesContract: `${BASE_URL}/sales-contract/update/`,
	downloadSalesContract: `${BASE_URL}/sales-contract/download/`,
	approveSalesContract: `${BASE_URL}/sales-contract/approve/`,
	createSalesContruct: `${BASE_URL}/sales-contract/create`,
	searchSalesContruct: `${BASE_URL}/sales-contract/all`,
	updateSalesContruct: `${BASE_URL}/sales-contract/update-in-order/`,

	// Terms and Conditions
	addTermToInvoice: `${BASE_URL}/terms-and-conditions/invoice/add-term/`,
	addTermToSalesContract: `${BASE_URL}/terms-and-conditions/sales-contract/add-term/`,
	deleteTerm: `${BASE_URL}/terms-and-conditions/delete-term`,
	updateTerm: `${BASE_URL}/terms-and-conditions/update-term/`,

	// Bank details
	updateBankDetails: `${BASE_URL}/bank-details/`,

	rejectClient: `${BASE_URL}/user/update-status/`,
	contactClientLater: `${BASE_URL}/user/client/contract-later/`,
	approveBuyer: `${BASE_URL}/user/client/tag-brand/`,
	filterCategories: `${BASE_URL}/collection/filter-categories`,
	addAndRemoveSize: `${BASE_URL}/rfq/add-remove-size`,
	userSearch: `${BASE_URL}/user/search`,
	getTeamLeads: `${BASE_URL}/user/team-leads/`,
	downloadUserWiseReport: `${BASE_URL}/collection/download-report`,

	// Commercial Invoice
	getSupplierListsOfCommercialInvoice: `${BASE_URL}/commercial-invoice/`,
	getCommercialInvoiceDetails: `${BASE_URL}/commercial-invoice/details/`,
	getCommercialInvoiceProductShipmentsQuantity: `${BASE_URL}/commercial-invoice/product-shipments/`,
	updateCommercialInvoiceProductShipmentsQuantity: `${BASE_URL}/commercial-invoice/product/`,
	completeCommercialInvoices: `${BASE_URL}/commercial-invoice/completed-product-shipment/`,
	updateCommercialInfoDocument: `${BASE_URL}/commercial-invoice/`,

	// Commercial Dashboard
	getCommercialDashboard: `${BASE_URL}/commercial-invoice/dashboard`,
	getUpcomingShipments: `${BASE_URL}/order/upcoming-shipments`,
	orderCommercialInvoice: `${BASE_URL}/mixpanel/event/add/ORDER_COMMERCIAL_INVOICE_VIEWED`,
	getPiAndSalesContractList: `${BASE_URL}/payment-document/order/all`,

	//Design Tool
	productAccessCheck: `${BASE_URL}/product/access-check/`,
	uploadProductDocument: `${BASE_URL}/product/doc/add-bulk/`,
	fetchProductInfo: `${BASE_URL}/product/design-info/`,
	deleteProductDocument: `${BASE_URL}/product/doc/`,
	collectionProductDocument: `${BASE_URL}/collection/`,
	addNewProductInCollection: `${BASE_URL}/product/v2/add`,
	storeArtBoard: `${BASE_URL}/art-board/add`,
	fetchArtBoard: `${BASE_URL}/art-board/product/`,
	updateArtBoard: `${BASE_URL}/art-board/`,
	updateArtBoardSerial: `${BASE_URL}/art-board/update-serial/product/`,
	fetchCollectionByProduct: `${BASE_URL}/product/all-in-collection/`,
	fetchAllDesignComment: `${BASE_URL}/product-development-comment/product/`,
	addNewPost: `${BASE_URL}/product-development-comment/new-post`,
	addPostReply: `${BASE_URL}/product-development-comment/new-comment`,
	sendToBd: `${BASE_URL}/product-development/send-to-bd`,
	generateArtBoardNumber: `${BASE_URL}/series/next-artboard-position/product/`,
	getGroupwiseDoc: `${BASE_URL}/product/groupwise-doc/`,
	mixpanelAddEvent: `${BASE_URL}/mixpanel/event/add/`,
	getProductQrCode: `${BASE_URL}/product/qr-code/`,
	// favourite page
	getFavouriteProducts: `${BASE_URL}/product/my-favourites`,
	getFavouriteMaterials: `${BASE_URL}/material/my-favourites`,
	getFavouriteMaterialsMax100: `${BASE_URL}/material/my-favourites/max-100`,
	// bill of landing
	billOfLandingAction: `${BASE_URL}/bill-of-landing/`,

	// sample
	fetchSampleRequest: `${BASE_URL}/sample/request/all`,
	fetchSampleRequestCount: `${BASE_URL}/sample/request/count`,
	fetchProductResponse: `${BASE_URL}/product/get-info`,
	sampleRequest: `${BASE_URL}/sample/request`,
	sampleDetailsAction: `${BASE_URL}/sample/request/`,
	getSampleRequestForAccountManagers: `${BASE_URL}/sample/counter-request/collection/`,
	getProductsWithSampleItemByCollection: `${BASE_URL}/sample/development-request/collection/`,
	photographyRequest: `${BASE_URL}/photography/request`,
	fetchPhotographyRequest: `${BASE_URL}/photography/all`,
	fetchPhotographyCount: `${BASE_URL}/photography/design-count`,
	fetchCollectionForPhotography: `${BASE_URL}/photography/collection/`,
	fetchCollectionForSample: `${BASE_URL}/collection/search/`,
	fetchCostingRequest: `${BASE_URL}/initial-costing/all`,
	fetchCostingRequestCount: `${BASE_URL}/initial-costing/design-count`,
	fetchCollectionForCosting: `${BASE_URL}/initial-costing/collection/`,
	processFromAllCost: `${BASE_URL}/initial-costing/process-from-all-cost`,
	addInitialCosting: `${BASE_URL}/initial-costing/add`,
	saveRecostingHistory: `${BASE_URL}/initial-costing/recosting-history`,
	fetchCostingHistory: `${BASE_URL}/initial-costing/costing-history`,
	fetchInitialCosting: `${BASE_URL}/initial-costing/product/`,
	updateCostingRemarks: `${BASE_URL}/initial-costing/update-remarks`,
	fetchQuantityWiseCost: `${BASE_URL}/quantity-wise-cost/product/`,
	saveQuantityWiseCost: `${BASE_URL}/quantity-wise-cost/add`,
	fetchSampleListPageFilter: `${BASE_URL}/sample/request/filter/all`,

	// quote
	requestQuote: `${BASE_URL}/quote/request`,
	quoteRequest: `${BASE_URL}/quote/`,
	fetchInitialCostingFromCosting: `${BASE_URL}/initial-costing/`,
	fetchQuantityWiseCostFromCosting: `${BASE_URL}/quantity-wise-cost/initial-costing/`,
	quantityWiseUpdatePrice: `${BASE_URL}/quantity-wise-cost/update-price`,
	sendOffer: `${BASE_URL}/quantity-wise-cost/send-offer`,
	fetchCollectionWiseCosting: `${BASE_URL}/quote/collection/`,
	fetchAllQuoteRequest: `${BASE_URL}/quote/request/all`,
	fetchQuoteCount: `${BASE_URL}/quote/request/count`,
	quoteAction: `${BASE_URL}/quote/`,
	removeVariant: `${BASE_URL}/quote/item/`,
	fetchQuoteListPageFilter: `${BASE_URL}/quote/request/filter-options`,
	updateEOD: `${BASE_URL}/quote/`,
	completeReview: `${BASE_URL}/initial-costing/complete-review`,
	getExFactorySupplierQuote: `${BASE_URL}/supplier-quote/{quoteId}/ex-factory`,

	// buyer request
	fetchBuyerRequests: `${BASE_URL}/buyer-request/all`,
	fetchBuyerRequestPriceRange: `${BASE_URL}/product/buyer-request/price-range/`,

	// moodboard
	moodboardAction: `${BASE_URL}/moodboard/`,
	addMoodBoard: `${BASE_URL}/moodboard/add-for-collection/`,
	updateMoodboardDetails: `${BASE_URL}/moodboard/update`,

	//extract file
	extractFile: `${BASE_URL}/po-extraction/extract`,
	submitExtract: `${BASE_URL}/po-extraction/submit`,

	fetchSubCategory: `${BASE_URL}/category/v2/subcategory`,
	updatePomName: `${BASE_URL}/product-measurement/point-of-measurement/`,
	removePomById: `${BASE_URL}/product-measurement/remove-point-of-measurement-by-library-POM`,
	fetchMyTeamMembers: `${BASE_URL}/user/my-teams`,

	getRunningCopyList: `${BASE_URL}/collection/product/running-copy-list`,

	getOrderDashboardReports: `${BASE_URL}/order-dashboard`,
	getOrderDashboardGroupWiseReports: `${BASE_URL}/order-dashboard/group-wise-count`,
	getDeliverableMasterData: `${BASE_URL}/deliverable/masters`,
	getTaskMasterData: `${BASE_URL}/deliverable/task-masters`,
	getCommercialInvoices: `${BASE_URL}/order-dashboard/commercial-invoice`,
	getFactories: `${BASE_URL}/order-dashboard/factory`,
	getOrders: `${BASE_URL}/order-dashboard/orders`,
	getPoNumbers: `${BASE_URL}/order-dashboard/po`,
	getSalesContracts: `${BASE_URL}/order-dashboard/sales-contracts`,
	getOrderStyles: `${BASE_URL}/order-dashboard/styles`,
	saveOrderDashboardRemarks: `${BASE_URL}/order-dashboard/remarks/`,
	getOrderDashboardSummary: `${BASE_URL}/order-dashboard/summary`,
	downloadOrderDashboardReports: `${BASE_URL}/order-dashboard/download`,
	getDeliverableDetails: `${BASE_URL}/deliverable/`,
	getOrderDashboardFilterOptions: `${BASE_URL}/order-dashboard/filter-options`,
	getOrderDashboardFilterOptionSearch: `${BASE_URL}/order-dashboard/filter-options/search`,
	getQcReportHtml: `${BASE_URL}/qc/reports/`,

	getCountryList: `${BASE_URL}/organogram/country/nitex-operations`,
	getCountryListByUnits: `${BASE_URL}/organogram/operational-units/`,
	getSupplierCountryList: `${BASE_URL}/supplier/supplier-countries`,
	getBrandApprovalChannel: `${BASE_URL}/organogram/operational-units/BRAND_APPROVAL_CHANNEL`,

	// Admin api
	getDepartmentList: `${BASE_URL}/department/all`,
	addDepartment: `${BASE_URL}/department/add`,
	getDepartment: `${BASE_URL}/department/`,
	editDepartment: `${BASE_URL}/department/`,
	deleteDepartment: `${BASE_URL}/department/`,

	//supplier
	fetchGarments: `${BASE_URL}/supplier/products`,
	fetchFixedTags: `${BASE_URL}/tags/fixed`,
	searchSupplier: `${BASE_URL}/supplier/search`,
	getAllMaterialStickersMax100: `${BASE_URL}/material/sticker/all/max-100`,
	downloadMaterialStickers: `${BASE_URL}/material/sticker/download`,
	downloadMaterialsExcel: `${BASE_URL}/material/excel/download`,
	deleteSupplierMaterial: `${BASE_URL}/supplier/material/delete`,
	fetchMaterialUnitType: `${BASE_URL}/material/unitType`,

	//order-cancel
	orderCancelRequest: `${BASE_URL}/order/cancel/request`,

	//CRM
	buyingCycle: `${BASE_URL}/crm/buying-cycle`,
	projection: `${BASE_URL}/projection`,
	projectionSummary: `${BASE_URL}/projection/summary`,
	addBrandBankDetails: `${BASE_URL}/brand/add-bank-details/`,
	BDMUsers: `${BASE_URL}/projection/bdms`,
	BDMOrderUsersList: `${BASE_URL}/order-dashboard/bdms`,
	getBrandSummary: `${BASE_URL}/order-dashboard/month-wise-summary`,
	orderSummary: `${BASE_URL}/order-dashboard/order-summary`,
	countryWiseSales: `${BASE_URL}/order-dashboard/order-summary-country-wise`,
	acManagerWiseSales: `${BASE_URL}/order-dashboard/order-summary-account-manager-wise`,
	brandWiseSales: `${BASE_URL}/order-dashboard/order-summary-brand-wise`,
	productGroupWiseSales: `${BASE_URL}/order-dashboard/order-summary-product-group-wise`,
	collectionTypeWiseSales: `${BASE_URL}/order-dashboard/order-summary-nitex-product-wise`,
	countryWiseProjection: `${BASE_URL}/projection/country-wise-projection-count`,
	bdmWiseProjection: `${BASE_URL}/projection/bdm-wise-projection-count`,
	brandWiseProjection: `${BASE_URL}/projection/brand-wise-projection-count`,
	orderWiseProjection: `${BASE_URL}/order-dashboard/order-wise-summary`,
	completeOrderSteps: `${BASE_URL}/step/complete`,
	projectionSummaryBrandWise: `${BASE_URL}/projection/summary-brand-wise`,
	monthWiseCommercialSummary: `${BASE_URL}/projection/month-wise-target-vs-achievement`,
	projectionHistory: `${BASE_URL}/projection/history`,
	calculateCRMDate: `${BASE_URL}/crm/calculate-date`,
	brandWiseCount: `${BASE_URL}/brand/status-wise-count`,
	brandAction: `${BASE_URL}/brand/`,

	//Favourite api
	favouriteUnseenCountApi: `${BASE_URL}/favourite/unseen-count`,
	getCRMBrandList: `${BASE_URL}/brand/allWithLogo/list`,

	//send cloudfront report
	sendCloudFrontReport: `${BASE_URL}/cloudfront-status/report`,

	//CRM V2
	getCRMWorkflowConfiguration: `${BASE_URL}/crm/workflow/my`,
	getCRMWorkflowMembers: `${BASE_URL}/crm/workflow/users/my-team`,
	CRMQuartersAction: `${BASE_URL}/crm/workflow/quarter`,
	getCRMTargetedYears: `${BASE_URL}/target/dropdown/list`,
	saveTarget: `${BASE_URL}/target`,
	getCRMTarget: `${BASE_URL}/target`,
	sendCRMTarget: `${BASE_URL}/target/send`,
	getCRMTargetSummary: `${BASE_URL}/target/summary`,
	setProjection: `${BASE_URL}/projection/add`,
	getCRMBrandWiseMonthlyProjection: `${BASE_URL}/projection/monthly`,
	getCrmWeeklylyProjection: `${BASE_URL}/projection/weekly`,
	sendProjection: `${BASE_URL}/target/send-projection`,
	updateApprovalStatus: `${BASE_URL}/target/update-approval-status`,
	sendApprovalStatus: `${BASE_URL}/target/approval-status/send`,
	getMyTargetedTears: `${BASE_URL}/target/years/my`,
	getBannerInfos: `${BASE_URL}/target/banner/my`,
	getCRMTargetById: `${BASE_URL}/target/`,
	getCRMQuarterList: `${BASE_URL}/crm/workflow/quarter/dropdown`,

	// Block Suggestion
	uploadProductFile: `${BASE_URL}/entity-file`,
	uploadProductFileNew: `${BASE_URL}/entity-file/upload`,
	fetchProductFile: `${BASE_URL}/entity-file/product/`,
	fetchProductBlocks: `${BASE_URL}/product/blocks`,
	fetchProductMeasurementBlockInfo: `${BASE_URL}/product-measurement/block-info/`,

	//File Section
	uploadEntityFile: `${BASE_URL}/entity-file/upload`,
	entityFile: `${BASE_URL}/entity-file`,

	//Collection presentation
	fetchPresentationDefaultImages: `${BASE_URL}/static-content/documents/PRESENTATION_COVER_DEFAULT_IMAGE`,
	removePresentationSequenceDoc: `${BASE_URL}/presentation/sequence/document-remove`,
	addPresentationSequence: `${BASE_URL}/presentation/sequence`,
	getPresentationSequence: `${BASE_URL}/presentation/sequence/`,
	getPresentationSequenceEmailContent: `${BASE_URL}/presentation/sequence/email-content-info/`,
	updateLeadTime: `${BASE_URL}/initial-costing/update-lead-time`,
	trackProductById: `${BASE_URL}/tracker/product/`,
	getPresentaionPsdFiles: `${BASE_URL}/archived-doc/product/`,
	removePresentaionPsdFile: `${BASE_URL}/archived-doc/`,
	uploadPresentaionPsdFile: `${BASE_URL}/archived-doc/product/`,
	getAuthGL: `${BASE_URL}/auth/gl`,

	//Measurement v3
	measurementSize: `${BASE_URL}/product-measurement/size/category`,
	getPomSize: `${BASE_URL}/product-measurement/point-of-measurement/all`,
	saveProductMeasurement: `${BASE_URL}/product-measurement/add-update/measurement-type-info`,
	productMeasurementBlockInfoAddUpdate: `${BASE_URL}/product-measurement/fitting-type-info/add-update`,
	copyMeasurementType: `${BASE_URL}/product-measurement/copy-to-same-product`,
	latestMeasurementTypes: `${BASE_URL}/product-measurement/all-measurement-type/product/`,
	copyMeasurementToAnotherProduct: `${BASE_URL}/product-measurement/copy-to-another-product`,
	blockInfoAddUpdate: `${BASE_URL}/product-measurement/block-info/add-update`,
	increaseSizeCategorySequence: `${BASE_URL}/product-measurement/increment-product-size-category-sequence`,
	removeSizeCategorySequence: `${BASE_URL}/product-measurement/remove-product-size-category-sequence`,
	setCurrentMeasurementType: `${BASE_URL}/product-measurement/current-measurement-type`,
	setMeasurementShowColumn: `${BASE_URL}/product/measurement/show-hide`,
	showAllHiddenSizeColumn: `${BASE_URL}/product/measurement/show-hidden-sizes`,
	initMeasurementTable: `${BASE_URL}/product-measurement/init-add/measurement-type-info`,
	duplicateMeasurement: `${BASE_URL}/product-measurement/duplicate/point-of-measurement/`,
	measurementRestoreHistory: `${BASE_URL}/product-measurement/history/`,

	//Collection Details
	productWiseTags: `${BASE_URL}/tags/all`,
	productStatus: `${BASE_URL}/product/sales-funnel/status-list`,
	updateNitexMargin: `${BASE_URL}/supplier-quote/update-nitex-margin/`,
	updateSupplierBulkQuote: `${BASE_URL}/supplier-quote/update-quote-bulk`,
	designPublishStatus: `${BASE_URL}/product/publish-status`,

	//CRM Sales funnel
	salesFunnel: `${BASE_URL}/sales-funnel`,
	salesFunnelFilterOptions: `${BASE_URL}/sales-funnel/filter-options`,
	salesFunnelSummary: `${BASE_URL}/sales-funnel/summary`,
	createAsNewStyle: `${BASE_URL}/collection/product/copy-as-new-style`,
	getUserBySearch: `${BASE_URL}/user/search`,
	groupWiseSalesFunnelCounts: `${BASE_URL}/sales-funnel/group-wise-count`,
	updateExpepectedOrderDate: `${BASE_URL}/sales-funnel/update/`,
	closeSalesFunnelStyle: `${BASE_URL}/sales-funnel/close-style/`,

	//Block library
	upDateProductBlock: `${BASE_URL}/assets/product-block/`,
	unmarkProductBlock: `${BASE_URL}/assets/product-block/`,
	getAllProductBlock: `${BASE_URL}/assets/product-block/library/all`,
	getBlockCardViewFilterOptions: `${BASE_URL}/assets/product-block/style/filter-options`,
	getBlockCollectionViewFilterOptions: `${BASE_URL}/assets/product-block/collection/filter-options`,

	//Sketch
	getAllSkectch: `${BASE_URL}/assets/sketch/all`,
	getSketchListFilterOptions: `${BASE_URL}/assets/sketch/filter-options`,
	sketchAction: `${BASE_URL}/assets/sketch/`,
	uploadBulkFiles: `${BASE_URL}/doc/add-bulk`,
	downLoadSingleFile: `${BASE_URL}/doc/download/`,
	removeDocFromSketch: `${BASE_URL}/assets/sketch/document/`,

	//ArtWork
	getAllArtWork: `${BASE_URL}/assets/artwork/all`,
	getArtworkListFilterOptions: `${BASE_URL}/assets/artwork/filter-options`,
	artworkAction: `${BASE_URL}/assets/artwork/`,
	removeDocFromArtwork: `${BASE_URL}/artwork/document/`,

	//Report
	downloadGMVReport: `${BASE_URL}/order/gmv/download`,
	downloadNMVReport: `${BASE_URL}/order/nmv/download`,
	inventoryReport: `${BASE_URL}/material/inventory/reports/download`,
	downloadNotificationReport: `${BASE_URL}/integration/development-tracker/notification/download`,
	downloadUpdateTrackerReport: `${BASE_URL}/integration/development-tracker/metabase-report`,

	//crm
	targetTeamMemberList: `${BASE_URL}/target/team-member-list`,
	addNewTarget: `${BASE_URL}/target/add`,
	getAllTarget: `${BASE_URL}/target/all`,
	countryWiseSummary: `${BASE_URL}/target/country-wise-summary`,
	yearWiseSummary: `${BASE_URL}/target/year-wise-summary`,
	targetYears: `${BASE_URL}/target/years`,
	target: `${BASE_URL}/target/`,
	CRMDashboardSummary: `${BASE_URL}/crm-dashboard/summary`,
	CRMOverallPerformance: `${BASE_URL}/crm-dashboard/overall-performance`,
	CRMBrandWisePerformance: `${BASE_URL}/crm-dashboard/brand-wise-performance`,
	CRMRegionWisePerformance: `${BASE_URL}/crm-dashboard/regional-performance`,
	CRMTeamWisePerformance: `${BASE_URL}/crm-dashboard/team-performance`,
	CompareBrandWisePerformance: `${BASE_URL}/crm-dashboard/brand-wise-performance/compare`,
	CompareRegionWisePerformance: `${BASE_URL}/crm-dashboard/regional-performance/compare`,
	CompareTeamWisePerformance: `${BASE_URL}/crm-dashboard/team-performance/compare`,
	CompareCRMOverallPerformance: `${BASE_URL}/crm-dashboard/overall-performance/compare`,
	CRMDashboardFilterOptions: `${BASE_URL}/crm-dashboard/filter-Options`,
	CRMDashboardYears: `${BASE_URL}/crm-dashboard/years`,
	crmIndividualPerformance: `${BASE_URL}/crm-dashboard/individual-performance`,
	restoreCRMProducts: `${BASE_URL}/sales-funnel/restore/bulk`,
	closeCRMProducts: `${BASE_URL}/sales-funnel/close/bulk`,
	bulkEODCRMProducts: `${BASE_URL}/sales-funnel/eod`,

	/** Partner Onboard **/
	invitePartner: `${BASE_URL}/supplier/invite-partner`,
	supplier: `${BASE_URL}/supplier`,
	supplierInfo: `${BASE_URL}/supplier/location-contact-info`,
	supplierBankInfo: `${BASE_URL}/supplier/bank-details`,
	supplierProductCategoryStrengths: `${BASE_URL}/supplier/product-category-strengths`,
	addSupplierPhotoDocuments: `${BASE_URL}/supplier/photo-documents/add`,
	materialCategories: `${BASE_URL}/material/branding/sub-categories`,
	updateUserStatus: `${BASE_URL}/user/partner/update-status`,

	// Product Locations
	productLocations: `${BASE_URL}/product-sample-inventory/location/search`,
	productLocationsAdd: `${BASE_URL}/product-sample-inventory/location/add`,
	productLocationsEdit: `${BASE_URL}/product-sample-inventory/location/`,
	updateSampleInventory: `${BASE_URL}/product-sample-inventory/`,
	singleLocation: `${BASE_URL}/product-sample-inventory/location/`,
	downloadInventoryStickers: `${BASE_URL}/product-sample-inventory/sticker/download`,

	/** Trend Research **/
	findTrendUserPreference: `${BASE_URL}/trend-research/user-preference`,
	saveTrendUserPreference: `${BASE_URL}/trend-research/user-preference/add`,
	updateTrendUserPreference: `${BASE_URL}/trend-research/user-preference/edit`,
	findTrendCategories: `${BASE_URL}/category/v2/all`,
	brandInsightList: `${BASE_URL}/trend-research/brand-insight/filter-options`,
	brandInsightSummary: `${BASE_URL}/trend-research/brand-insight/summary`,
	brandInsightSummaryByCategoryAndMarket: `${BASE_URL}/trend-research/brand-insight/count-by-category-and-market`,
	brandInsight: `${BASE_URL}/trend-research/brand-insight`,
	trendInsight: `${BASE_URL}/trend-research`,
	trendMoodBoard: `${BASE_URL}/trend-mood-board`,
	addTrendMoodBoard: `${BASE_URL}/trend-mood-board/add`,
	fabricSummary: `${BASE_URL}/trend-research/brand-insight/fabric-summary`,
	trendProducts: `${BASE_URL}/trend-research/BRAND/products`,
	instagramInfluencerList: `${BASE_URL}/trend-research/instagram-insight/influencer-list`,
	imageSearchHistory: `${BASE_URL}/trend-research/image-search/history`,
	imageSearch: `${BASE_URL}/trend-research/image-search`,
	trendMoodBoardProducts: `${BASE_URL}/trend-mood-board/products`,
	myTrendMoodBoard: `${BASE_URL}/personal-setting/moodboard-preference`,
	setMyMoodBoard: `${BASE_URL}/personal-setting/set`,

	// Favourite
	getFavouriteFolders: `${BASE_URL}/user/favourites/my-folders`,
	folderList: `${BASE_URL}/user/favourites/folder-details-list`, // Details page
	folderListWithSearch: `${BASE_URL}/user/favourites/my-folders`,
	createFavouriteFolder: `${BASE_URL}/user/favourites/admin-add-folder`,
	getFolderById: `${BASE_URL}/user/favourites/folder-details`,
	addMemberToFavourite: `${BASE_URL}/user/favourites/folder`,
	removeMemberFromFavourite: `${BASE_URL}/user/favourites/folder/`,
	deleteFolder: `${BASE_URL}/user/favourites/folder/`,
	linkCollection: `${BASE_URL}/user/favourites/folder/`,
	unlinkCollection: `${BASE_URL}/user/favourites/folder/`,
	getUnlinkedCollections: `${BASE_URL}/user/favourites/folder/`,
	updateFolder: `${BASE_URL}/user/favourites/admin-update-folder/`,
	updateBuyerRemarks: `${BASE_URL}/user/favourites/update-sheet/`,
	changeFolder: `${BASE_URL}/product/liked/`,
	bulkUnlikeMaterials: `${BASE_URL}/material/unlike`,
	getFavouriteListFilterOptions: `${BASE_URL}/user/favourites/filter-options`,
	getFavouriteConversation: `${BASE_URL}/conversation/favourite-folder`,

	///materialList
	getMaterialTaskList: `${BASE_URL.replace(/\/api(?:\/core)?\/?$/, '')}/app/request/api/dashboard/my`,
	getMaterialTaskListByFilter: `${BASE_URL.replace(/\/api(?:\/core)?\/?$/, '')}/app/request/api/dashboard/list`,

	// Favourite draft
	addToDraft: `${BASE_URL}/user/favourites/draft`,
	removeFromDraft: `${BASE_URL}/user/favourites/undraft/`,

	// Presentation
	getPresentationInfo: `${BASE_URL}/presentation/`,
	addPresentation: `${BASE_URL}/presentation/add`,
	getPresentationLink: `${BASE_URL}/presentation/identifier/`,
	hidePresentation: `${BASE_URL}/product/`,

	// Range Plan
	addRangePlanItem: `${BASE_URL}/range-planning/add`,
	removeRangePlanItem: `${BASE_URL}/range-planning/`,
	toggleTarget: `${BASE_URL}/range-planning/target-info/entity/`,
	getRangePlanTableData: `${BASE_URL}/range-planning/entity/`,
	updateRangePlaningTarget: `${BASE_URL}/range-planning/update`,
	fitTypeTags: `${BASE_URL}/tags/all`,
	downloadRangePlan: `${BASE_URL}/range-planning/`,
	rangePlan: `${BASE_URL}/range-planning/`,
	getFabricCompositions: `${BASE_URL}/material/fabric/composition-name-list`,
	getFabricConstraction: `${BASE_URL}/material/fabric/constructions`,
	pinFolder: `${BASE_URL}/user/favourites/folder/`,

	// Project
	addNewProjectPost: `${BASE_URL}/conversation/new-post`,
	getProjectConversation: `${BASE_URL}/conversation/project-task/`,
	toggleLockAndUnlock: `${BASE_URL}/product/lock-status`,
	createProductsOption: `${BASE_URL}/collection/product/create-options`
};

// Axios request interceptor
axios.interceptors.request.use((config) => {
	const token = localStorage.getItem('token');
	const userInfo = JSON.parse(localStorage.getItem('userInfo'));
	config.headers.Authorization = token ? token : '';
	config.headers.unameid = userInfo?.id || '';
	config.headers.unamefull = userInfo?.name?.replace(/[^a-zA-Z\s]/g, '?') || '';
	config.headers.xfurl = window.location.pathname + window.location.search || '';
	let geoInfo = sessionStorage.getItem('glInfo');
	if (geoInfo !== null) {
		geoInfo = JSON.parse(geoInfo);
		config.headers.xglid = geoInfo.glid;
		config.headers.xuglid = geoInfo.uglid;
	}
	return config;
});

// Axios response interceptor
axios.interceptors.response.use(
	(response) => {
		// Record successful API call
		deploymentDetector.recordSuccess();

		if (response.config.url.includes('logout')) {
			delete axios.defaults.headers.common['Authorization'];
		}
		return response;
	},
	(error) => {
		// Check if this is a deployment-related error
		const isDeploymentError = deploymentDetector.recordError(error);

		// If it's a deployment error, reject with a special error to prevent retries
		// The deployment UI will handle user communication
		if (isDeploymentError && deploymentDetector.isDeploying()) {
			// Reject immediately to prevent hanging promises and memory leaks
			return Promise.reject({
				isDeploymentError: true,
				message: 'Backend is deploying',
				suppressError: true
			});
		}

		// Handle unauthorized errors normally
		if (error?.response?.data?.status === HTTP_STATUS['Unauthorized'] && localStorage.getItem('token')) {
			localStorage.removeItem('token');
			delete axios.defaults.headers.common['Authorization'];
			window.location.replace(BASE_FRONT_END_URL);
		}

		return Promise.reject(error);
	}
);

const encodeQueryData = (data) => {
	let ret = [],
		temp;
	for (let i in data) {
		temp = data[i];
		if (temp !== '' && temp !== null && temp !== undefined) {
			ret.push(encodeURIComponent(i) + '=' + encodeURIComponent(temp));
		}
	}
	return ret.length ? '?' + ret.join('&') : '';
};

const ApiClient = {
	GET: (key, params = '', isRestFormat = false, optional = {}) => {
		params = typeof params === 'object' ? encodeQueryData(params) : params;
		if (isRestFormat) {
			return axios.get(key + params, { headers: { ...headers }, ...optional });
		} else {
			return axios.get(routes[key] + params, { headers: { ...headers }, ...optional });
		}
	},
	GET_FILE_DATA: (key, params = '', isRestFormat = false) => {
		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Content-Disposition': 'attachment'
			},
			responseType: 'blob'
		};
		params = typeof params === 'object' ? encodeQueryData(params) : params;
		if (isRestFormat) {
			return axios.get(key + params, config);
		} else {
			return axios.get(routes[key] + params, config);
		}
	},
	POST: (key, requestBody, params = '', isRestFormat = false) => {
		if (isRestFormat) {
			return axios.post(key + params, requestBody, { headers: headers });
		} else {
			return axios.post(routes[key] + params, requestBody, { headers: headers });
		}
	},
	PUT: (key, params, id = '', isRestFormat = false) => {
		if (isRestFormat) {
			return axios.put(key + id, params, { headers: headers });
		} else {
			return axios.put(routes[key] + id, params, { headers: headers });
		}
	},
	PATCH: (key, params, id = '', isRestFormat = false, isParam = false) => {
		if (isRestFormat) {
			return axios.patch(key + id, params, { headers: headers });
		} else if (isParam) {
			return axios.patch(routes[key] + id + params, { headers: headers });
		} else {
			return axios.patch(routes[key] + id, params, { headers: headers });
		}
	},
	DELETE: (key, data, id = '', isRestFormat = false) => {
		if (isRestFormat) {
			return axios.delete(key + id, { data, headers });
		} else {
			return axios.delete(routes[key] + id, { data, headers });
		}
	},
	DELETE_WITH_BODY: (key, body, params = '') => {
		params = typeof params === 'object' ? encodeQueryData(params) : params;
		return axios.delete(routes[key] + params, { headers, data: body });
	},
	UPLOAD_MULTIPLE_FILE: (key, files = [], id, responseType, fileParamName = 'file') => {
		let formData = new FormData();
		files.forEach((file) => {
			formData.append(fileParamName, file);
		});
		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Content-Disposition': 'attachment'
			}
		};
		if (!responseType) {
			config['responseType'] = 'blob';
		}
		return axios.post(routes[key] + id, formData);
	},

	UPLOAD_MULTIPLE_FILE_WITH_BODY: (key, files, responseType) => {
		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Content-Disposition': 'attachment'
			}
		};
		if (!responseType) {
			config['responseType'] = 'blob';
		}
		return axios.post(routes[key], files, config);
	},

	DOWNLOAD: (key, params = '', id) => {
		return axios.post(routes[key] + id, params, {
			headers: {
				'Content-Disposition': 'attachment'
			},
			responseType: 'blob'
		});
	},

	DOWNLOAD_GET: (key, id, params = '') => {
		return axios.get(routes[key] + id + params, {
			headers: {
				'Content-Disposition': 'attachment'
			},
			responseType: 'blob'
		});
	}
};
export default ApiClient;
